import { LANGUAGE, type LanguageEnumBaseData, type LanguageEnumBaseExtraData, languageEnumBase } from '@nfctron/nexus-core';
import { AmericaFlagIcon, CzechiaFlagIcon, GermanyFlagIcon, SlovakiaFlagIcon } from '@nfctron/nexus-react-svg';

import { type SvgIconComponent } from '@root/lib/types/components';

import { EnumHelper } from './helpers';

/**
 * Extra data extension for Languages in Tickets project
 */
export interface LanguageEnumTicketsExtraDataExtend {
	Icon?: SvgIconComponent;
	isSupported?: boolean;
}

/**
 * Combined data interface for Language Enum in Tickets
 */
export interface LanguageEnumTicketsData extends LanguageEnumBaseData, LanguageEnumTicketsExtraDataExtend {}

/**
 * Language enumeration with extra data for Tickets
 */
class LanguageEnumTickets extends EnumHelper<
	LanguageEnumBaseExtraData & LanguageEnumTicketsExtraDataExtend,
	LANGUAGE,
	typeof languageEnumBase.enumName,
	typeof languageEnumBase.idKey
> {
	constructor() {
		super(
			languageEnumBase.enumName,
			languageEnumBase.data,
			languageEnumBase.idKey,
			languageEnumBase.extendWith({
				[LANGUAGE.CZECH]: {
					Icon: CzechiaFlagIcon,
					isSupported: true,
				},
				[LANGUAGE.ENGLISH]: {
					Icon: AmericaFlagIcon,
					isSupported: true,
				},
				[LANGUAGE.SLOVAK]: {
					Icon: SlovakiaFlagIcon,
					isSupported: true,
				},
				[LANGUAGE.GERMAN]: {
					Icon: GermanyFlagIcon,
					isSupported: true,
				},
				[LANGUAGE.FRENCH]: {
					isSupported: false,
				},
				[LANGUAGE.SPANISH]: {
					isSupported: false,
				},
				[LANGUAGE.RUSSIAN]: {
					isSupported: false,
				},
				[LANGUAGE.NORWEGIAN]: {
					isSupported: false,
				},
				[LANGUAGE.SWEDISH]: {
					isSupported: false,
				},
			}),
		);
	}
}

/**
 * Language enumeration singleton instance export
 */
export const languageEnumTickets = new LanguageEnumTickets();

/**
 * Re-export LANGUAGE for local imports
 */
export { LANGUAGE };
